module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/operator-info.45432e86.svg";